import {Fragment, h} from "preact";
import Product from "./Product";
import s from "./productList.module.css";
import {productDelivery, typeClinicalAnalysis, typeVaccine} from "../../../../../assets";
import {useAppContext} from "../../../../../contexts";

const BADGE_DATA = {
    vaccines: {
        icon: typeVaccine,
        label: "Vacinas"
    },
    clinical_analysis: {
        icon: typeClinicalAnalysis,
        label: "Exames Laboratoriais"
    },
    general: {
        icon: typeClinicalAnalysis,
        label: "Produtos"
    }
}

const ProductList = (props) => {
    // Destructured props
    const {
        data,
        cartData,
        updateCart,
        target
    } = props;

    // The actual product list
    const products = data ? data.map(item => {
        // Retrieves the item stock data
        const stockData = item["stockData"].find((stock) => {
            return stock.id === item.stockItem;
        });
        // Checks if product is out of stock
        const isOutStock = cartData.qtyItems + 1 > stockData?.stockQty;

        return (
            <Product
                key={item.id}
                item={item}
                updateCart={updateCart}
                incrementDisable={isOutStock}
            />
        )
    }) : null;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Prevents from rendering the container
    // if no products exist for the given category.
    if (products.length < 1) {
        return null;
    }

    // The variable name already says it all
    const badgeInfo =
        !data.some(product => product.cep) ? (
            <p className={"text-ellipsis overflow-hidden"}>
                {/*{BADGE_DATA["general"].label}*/}
                Unidade -
                <span>
                    &nbsp;{target}
                </span>
            </p>
        ) : (
            <p className={"text-ellipsis overflow-hidden"}>
                {/*{BADGE_DATA["general"].label}*/}
                Vem Sabin -
                <span>
                    &nbsp;{target}
                </span>
            </p>
        );

    return (
        <Fragment>
            <ul className={`${s.list}`}>
                <div className={s.badgeContainer}>
                    <div className={s.badge}>
                        <div className={`${s.pill} ${highContrast ? s.highContrastPill : ""}`} />
                        <img
                            src={productDelivery}
                            alt="Icon"
                        />
                        {badgeInfo}
                    </div>
                </div>
                {products}
            </ul>
        </Fragment>
    )
}

export default ProductList;
